import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Edit3, LockKeyhole, Share2 } from 'lucide-react';
import { Btn } from '../shared';
import { PassportPortrait } from './Primitives';
import { PassportBrandBar } from '../passports/PassportBrandBar';
import { useAuth } from '../../context/Auth';
import { CompactPlayerHeader } from './CompactPlayerHeader';
import '../../styles/compact-player-header.css';

export const PlayerPassportHeader = ({ athlete, owner, mediaUrl, onShare, onEdit }) => {
  const [compact, setCompact] = useState(false);
  const [phone, setPhone] = useState(() => window.matchMedia('(max-width: 430px)').matches);
  const { user } = useAuth();
  const backTo = owner ? `/parent/athletes/${athlete.id}` : user?.role === 'trainer' ? '/dashboard' : '/parent';
  useEffect(() => {
    const query = window.matchMedia('(max-width: 430px)');
    const update = () => setPhone(query.matches);
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);
  useEffect(() => {
    const scroll = () => setCompact(window.scrollY > 120);
    scroll(); window.addEventListener('scroll', scroll, { passive: true });
    return () => window.removeEventListener('scroll', scroll);
  }, []);
  const bar = <PassportBrandBar id="pp" backTo={backTo} backLabel={owner ? 'Athlete workspace' : 'My workspace'} compact={compact} compactTitle={`${athlete.name.trim().split(/\s+/)[0]}'S PASSPORT`} />;
  if (phone) return <>{bar}<CompactPlayerHeader athlete={athlete} owner={owner} compact={compact} mediaUrl={mediaUrl} onShare={onShare} onEdit={onEdit} /></>;
  return <>
    {bar}
    <header className="pp-header" data-testid="pp-header">
      <div className="pp-heading-copy">
        <p className="eyebrow" data-testid="pp-collection">THE PLAYER COLLECTION</p>
        <h1 className="passport-stone-type" data-testid={compact ? 'pp-opening-title' : 'pp-header-title'}>PLAYER PASSPORT</h1>
        <p className="pp-header-tagline" data-testid="pp-header-tagline">Your journey. Your growth. Your passport.</p>
      </div>
      <span className="pp-lock-label" data-testid="pp-audience"><LockKeyhole size={13} />{owner ? 'Parent view' : 'Invited view'}</span>
    </header>
    {owner && <Link className="back-link pp-workspace-link" data-testid="pp-workspace-link" to={`/parent/athletes/${athlete.id}`}><ArrowLeft size={13} />Athlete workspace</Link>}
    <section className="pp-hero" data-testid="pp-hero">
      <div className="pp-identity-card" data-testid="pp-athlete-identity-card">
      <PassportPortrait src={mediaUrl(athlete.photo_id)} name={athlete.name} id="pp-athlete-photo" large />
      <div className="pp-athlete-identity">
        <p className="pp-player-name passport-stone-type" data-testid="pp-athlete-name">{athlete.name}</p>
        <p className="pp-sport" data-testid="pp-sport"><span />BASEBALL</p>
        <p className="pp-positions" data-testid="pp-positions">{athlete.positions.join(' · ')}</p>
        <dl className="pp-handedness"><div><dt>BATS</dt><dd data-testid="pp-bats">{athlete.bats || 'Not added'}</dd></div><div><dt>THROWS</dt><dd data-testid="pp-throws">{athlete.throws || 'Not added'}</dd></div><div data-testid="pp-hero-age-row"><dt data-testid="pp-age-label">AGE</dt><dd data-testid="pp-age">{athlete.age ?? '—'}</dd></div></dl>
        <span className="pp-lock-label pp-managed" data-testid="pp-parent-managed"><LockKeyhole size={12} />Profile managed by parent</span>
        {owner && <button className="pp-text-button" data-testid="pp-edit-baseball-button" onClick={onEdit}><Edit3 size={13} />Edit baseball details</button>}
      </div>
      </div>
      <div className="pp-hero-aside">
        <p className="pp-mantra" data-testid="pp-mantra">SAME GAME.{' '}<br />BIGGER <span>POTENTIAL.</span></p>
        {owner && <Btn className="pp-primary pp-share-button" data-testid="pp-share-button" onClick={onShare}><Share2 />Share Passport</Btn>}
        <span className="pp-invitation-label" data-testid="pp-invitation-label"><LockKeyhole size={11} />Shared by invitation</span>
      </div>
    </section>
  </>;
};